export const GROWTH_LUNA_EXPERIMENT = {
	RECOMMEND_STANDARD_BUY_PREMIUM_EOT_MODAL_SEEN:
		'growth-luna-recommend-standard-buy-premium:treatmentModalSeen',
};
